import React, { useMemo } from 'react';
import styles from './field-description.scss';
import { RicosViewerLazy } from '../../loadable';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
const getCustomThemeClass = compId => "description-custom-theme" + (compId != null ? compId : '');
export const FieldDescription = _ref => {
  let {
    description,
    id
  } = _ref;
  const {
    compId
  } = useConfig();
  const customTheme = useMemo(() => getCustomTheme({
    compId
  }), [compId]);
  return description ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.description, getCustomThemeClass(compId)),
    "aria-hidden": "true",
    id: id
  }, /*#__PURE__*/React.createElement(RicosViewerLazy, {
    content: description,
    customTheme: customTheme
  })) : null;
};
const getCustomTheme = _ref2 => {
  let {
    compId
  } = _ref2;
  return {
    parentClass: getCustomThemeClass(compId),
    customStyles: {
      p: {
        fontSize: 'var(--wix-forms-formInputNoteFont-size)',
        fontFamily: 'var(--wix-forms-formInputNoteFont-family)',
        color: 'rgb(var(--wix-forms-formInputNoteColor))'
      }
    }
  };
};
//# sourceMappingURL=field-description.js.map